import { styled, Tag, SvgIcon } from '@teko/ui';
import React from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getBorderColor = (props) => {
  return props.isActive ? props.theme.brand.primary : "#e0e0e0";
};
const getColor = (props) => {
  return props.isActive ? props.theme.brand.primary : "#333333";
};
const Wrapper = styled.div((props) => `
  border-radius: 4px;
  display: inline-block;
  user-select: none;
  border: solid 1px ${getBorderColor(props)};
  background-color: ${props.activeBackground && props.isActive ? props.activeBackground : "#fff"};
  padding: 0.5rem 1.25rem;
  position: relative;
  overflow: hidden;
  cursor: ${props.isDisabled ? "default" : "pointer"};
  ${props.block ? "width: 100%;" : ""}

  &:hover {
    background: ${props.isActive || props.isDisabled ? "" : "#f3f3f3"} ;
  }
  `);
const Title = styled.div((props) => `
  color: ${props.activeBackground && props.isActive ? getColor(props) : ""};
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 0.875rem;
 `);
const ActiveBorder = styled.div((props) => `
  position: absolute;
  top: -1px;
  right: -1px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: ${props.stickySize === "sm" ? "0px 20px 20px 0px" : "0px 36px 36px 0px"};
  border-color: transparent ${props.theme.brand.primary} transparent transparent;
`);
const Checked = styled.span((props) => `
  position: absolute;
  top: ${props.stickySize === "sm" ? "-4px" : "0"};
  right: ${props.stickySize === "sm" ? "2px" : "6px"};
  color: #fff;
  z-index: 0;
  font-size: ${props.stickySize === "sm" ? "7px" : "10px"};
`);
const IconWrappper = styled.span`
  margin-left: 8px;
`;
const StyledTag = styled(Tag)`
  margin-left: 8px;
`;
const SubTitle = styled.p`
  margin-bottom: 0.5rem;
  color: #848788;
`;
const Overlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #d8d8d852;
  z-index: 1;
`;
const SelectOption = (_a) => {
  var _b = _a, {
    title,
    subTitle,
    children,
    icon,
    tag,
    isActive,
    onClickOption,
    onClickIcon,
    onMouseEnter,
    activeBackground,
    stickySize,
    isDisabled,
    tags
  } = _b, props = __objRest(_b, [
    "title",
    "subTitle",
    "children",
    "icon",
    "tag",
    "isActive",
    "onClickOption",
    "onClickIcon",
    "onMouseEnter",
    "activeBackground",
    "stickySize",
    "isDisabled",
    "tags"
  ]);
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadValues({
    activeBackground,
    isActive: !isDisabled && isActive,
    onClick: (ev) => !isDisabled && onClickOption(ev),
    onMouseEnter,
    isDisabled
  }, props), isDisabled && /* @__PURE__ */ React.createElement(Overlay, null), /* @__PURE__ */ React.createElement(Title, {
    activeBackground,
    isActive: !isDisabled && isActive
  }, title, " ", tag && /* @__PURE__ */ React.createElement(StyledTag, __spreadValues({}, tag)), " ", (tags == null ? void 0 : tags.length) > 0 && tags.map((value) => /* @__PURE__ */ React.createElement(StyledTag, __spreadValues({
    key: String(value.children)
  }, value))), icon && /* @__PURE__ */ React.createElement(IconWrappper, {
    onClick: onClickIcon
  }, /* @__PURE__ */ React.createElement(SvgIcon, __spreadValues({}, icon)))), subTitle && /* @__PURE__ */ React.createElement(SubTitle, null, subTitle), children, !isDisabled && isActive && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ActiveBorder, {
    stickySize
  }), /* @__PURE__ */ React.createElement(Checked, {
    stickySize
  }, "\u2713")));
};

export { SelectOption };
